import { consumptionAPI } from "./clients";

const endpoint = `/metrics`;
/**
 * Endpoint to get the list of all Metrics available
 */
const getMetricsList = () => {
  return consumptionAPI.get(endpoint);
};

/**
 * Endpoint to create a new metric
 * @param {Object} data
 */
const createMetric = data => {
  return consumptionAPI.post(endpoint, data);
};

/**
 * Endpoint to get details of a single Metric
 * @param {String} metric_id
 */
const getMetricDetails = metric_id => {
  const url = `${endpoint}/${metric_id}`;
  return consumptionAPI.get(url);
};

/**
 * Endpoint to get all the extras required for metric creation
 * Aggregation items, supported operations and comparisons
 */
const getExtras = () => {
  const url = `/extra`;
  return consumptionAPI.get(url);
};

export { getMetricsList, getMetricDetails, createMetric, getExtras };
